import { render, staticRenderFns } from "./Licensing.vue?vue&type=template&id=42b95be8"
import script from "./Licensing.vue?vue&type=script&lang=js"
export * from "./Licensing.vue?vue&type=script&lang=js"
import style0 from "./Licensing.vue?vue&type=style&index=0&id=42b95be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports